export enum SmerRazeniEnum {
	VZESTUPNE = 'VZESTUPNE',
	SESTUPNE = 'SESTUPNE'
}
